import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Col, Flex, Row, Table } from "antd";
import { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";

const TableComponent = (props) => {
  const {
    columns,
    dataSource,
    rowSelection,
    pageSize = 15,
    showPagination = true,
    page = 1,
    totalPage = 0,
    onChangePage = () => {},
    onChange = () => {},
    rowClassName = ''
  } = props;
  const { t } = useTranslation();

  return (
    <div className="table-common-container">
      <Table
        columns={columns}
        locale={{ emptyText: "データがありません" }}
        dataSource={dataSource}
        bordered
        rowSelection={rowSelection}
        scroll={{ y: window.innerHeight > 800 ? 500 : 350 }}
        onChange={onChange}
        pagination={false}
        rowClassName={rowClassName}
      />
      {showPagination && (
        <div className="footer">
          <Row
            style={{
              marginTop: "20px",
              justifyContent: "flex-end",
              padding: "0 20px",
            }}
          >
            <Col style={{ display: "flex" }}>
              {`${page}/${totalPage} ${t("pagination")}　`}
              <Flex gap="10px">
                {page > 1 ? (
                  <span
                    style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                    onClick={() => {
                      onChangePage(page - 1);
                    }}
                  >
                    ▶
                  </span>
                ) : null}
                {page < totalPage ? (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      onChangePage(page + 1);
                    }}
                  >
                    ▶
                  </span>
                ) : null}
              </Flex>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};
export default TableComponent;
